import { Link as RRDLink } from "react-router-dom";

const Link = ({ to, children, ...rest }) => {
  const url = new URL(to);
  url.host = "";

  return (
    <RRDLink {...rest} to={`${url.pathname}${url.search}`}>
      {children}
    </RRDLink>
  );
};

export default Link;
